import { useRouter } from 'next/router';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TimelineMax, TweenMax } from 'gsap';
import CommunityE from 'elem/compPage/Community';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import CommunityPc from '@/components/Community';
import CommunityH5 from '@/componentsH5/Community';
import { useGlobal } from '@/utils/useGlobal';
import { redirectTo404 } from '@/utils';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import { seoConfig } from '@/constants/community';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function Community({ SEO, lang }: any) {
    const { isMobile } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('communitylang');
    let CommunityPage = isMobile ? CommunityH5 : CommunityPc;
    const NEW_PAGE_SITE = ['us', 'ca'];
    if (NEW_PAGE_SITE.includes(locale)) {
        CommunityPage = CommunityE;
    }

    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.controllerDay = new ScrollMagic.Controller();
    }

    return (
        <div className={css.community}>
            <SEO title={t('seoTitle')} description={t('seoDesc')} hideTitleTemplate />
            <SEOlinksA locale={String(locale)} list={seoConfig.locales} pathname={seoConfig.url} />
            <div className="eco-credits__box">
                <PageLayout isNoFixed>
                    <CommunityPage />
                </PageLayout>
            </div>
        </div>
    );
}

export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = seoConfig.locales;
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
